// extracted by mini-css-extract-plugin
export var cardHeader = "_k4-0";
export var reorderHandle = "_k4-3";
export var titleArea = "_k4-1";
export var titleAreaWithHandle = "_k4-2";